import React, { useEffect } from 'react';

const AdInFeed = ({currentPath,slot,layoutKey}) => {

    const adYn = window.location.hostname == 'localhost' ||  window.location.hostname == 'devkorea.tripcheckiner.com' ? false : true;
 
    useEffect(() => {
        if(adYn){
            window.adsbygoogle = window.adsbygoogle || []
            window.adsbygoogle.push({})
        }
    },[currentPath,adYn]);
    if(adYn){
        return (
            <div style={{paddingTop:"5px",paddingBottom:"10px"}} key={currentPath}>
            <ins className="adsbygoogle"
                style={{display:"block"}}
                data-ad-format="fluid"
                data-ad-layout-key={layoutKey}
                data-ad-client="ca-pub-3520354069848238"
                data-ad-slot={slot}></ins>
            </div>
        );
    } else {
        return (
            <>
            </>
        );
    }
};

export default AdInFeed;